import axios from 'axios';
import config from '../constants/config.js';

const MAX_DISTANCE_FROM_ADDRESS = 10;

export default {
  methods: {
    async geocodeAddress(address, zip){
      const requestUrl = config.GOOGLE_GEOCODING_BASE_URL + address + zip + '&key=' + config.GOOGLE_GEOCODING_API_KEY
      const result = await axios.get(requestUrl);
      if(result.data.status === 'OK'){
        const geocodingResult = result.data.results[0];
        console.log(geocodingResult);
        return {
          latLong: geocodingResult.geometry.location,
          formattedAddress: geocodingResult.formatted_address
        }
      }
      else {
        console.log('no results')
      }
    },
    getUrlVars() {
      var vars = {};
      window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,
      function(m,key,value) {
        vars[key] = value;
      });
      return vars;
    },
    calculateDistance(lat1, lon1, lat2, lon2) { // This function takes in latitude and longitude of two location and returns the distance between them as the crow flies (in km)
      var R = 6371; // km
      var dLat = this.toRad(lat2-lat1);
      var dLon = this.toRad(lon2-lon1);
      var radLat1 = this.toRad(lat1);
      var radLat2 = this.toRad(lat2);

      var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
          Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(radLat1) * Math.cos(radLat2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
      var d = R * c;
      return d / 1.6; // convert from km to miles
    },
    toRad(Value) // Converts numeric degrees to radians
    {
      return Value * Math.PI / 180;
    },
    getClosestSchools(schools, currentLat, currentLong) {
      schools.forEach(school => {
        school.distanceFromAddr = this.calculateDistance(currentLat, currentLong, school.latLong.lat, school.latLong.lng).toFixed(1); // round to 1 decimal place with toFixed()
      });

      schools = schools.filter(school => {
        return school.distanceFromAddr < MAX_DISTANCE_FROM_ADDRESS;
      });
      return schools.sort((a, b) => (a.distanceFromAddr > b.distanceFromAddr) ? 1 : -1);
    },
    getHelpEmailAddress(){
      return "mailto: esa@poweredbyeducation.org";
    }
  }
}
